import { useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";

import ContentDrawerComponent from "./ContentDrawer/ContentDrawerComponent";
import { sectionCss, drawersCss } from "./ContentDrawerGroup.style";
import ContentDrawerToggle from "./ContentDrawerToggle";

type IContentDrawerGroupComponentProps = {
  node: {
    attrs: {
      label: string;
      drawers: { title: string; content: string }[];
      hasDrawerToggleBtn?: boolean;
      hideContent?: boolean;
    };
  };
};

const ContentDrawerGroupComponent = ({
  node,
}: IContentDrawerGroupComponentProps) => {
  const {
    label,
    drawers,
    hasDrawerToggleBtn = true,
    hideContent = false,
  } = node.attrs;
  const [allCollapsed, setAllCollapsed] = useState(true);

  const toggleAll = () => setAllCollapsed((prev) => !prev);

  const shouldDisplayToggle =
    hasDrawerToggleBtn && drawers.length > 1 && !hideContent;

  return (
    <NodeViewWrapper as="div">
      <div css={sectionCss}>
        {label && <h3>{label}</h3>}
        {shouldDisplayToggle ? (
          <ContentDrawerToggle
            label={label}
            toggleAll={toggleAll}
            allCollapsed={allCollapsed}
          />
        ) : (
          <></>
        )}
      </div>
      <ul css={drawersCss} role="group">
        {drawers.map(({ title, content }, idx) => (
          <li key={idx}>
            <ContentDrawerComponent
              title={title}
              isCollapsed={allCollapsed}
              hideContent={hideContent}
            >
              {content}
            </ContentDrawerComponent>
          </li>
        ))}
      </ul>
    </NodeViewWrapper>
  );
};

export default ContentDrawerGroupComponent;
